import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AssessmentProvider } from "./lib/AssessmentContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const AssessmentPage = lazy(() => import("./pages/AssessmentPage"));
const ScorecardPage = lazy(() => import("./pages/ScorecardPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage }))
);

export function App() {
  return (
    <ErrorBoundary>
      <AssessmentProvider>
        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100dvh",
                color: "var(--color-text-muted)",
              }}
            >
              Loading...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/assess" element={<AssessmentPage />} />
            <Route path="/scorecard" element={<ScorecardPage />} />
            <Route path="/scorecard/:id" element={<ScorecardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/dashboard/:id" element={<DashboardPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </AssessmentProvider>
    </ErrorBoundary>
  );
}
